// 设备调试角色
const deviceAuth = [
	{
		icon: "iconfont icon-shouye-shouye",
		router: "/admin/index",
		name: "首页",
	},
	{
		icon: "iconfont icon-xiangmuguanli",
		router: "/admin/project",
		name: "项目管理",
	},
	{
		icon: "iconfont icon-jianxiujihua",
		router: "/admin/device",
		name: "设备管理",
	},
	// {
	// 	icon: "iconfont icon-diantianquanjiankongxitong",
	// 	router: "/admin/product",
	// 	name: "产品型号",
	// },
	// {
	// 	icon: "iconfont icon-kehu",
	// 	router: "/admin/user",
	// 	name: "用户管理",
	// },
	// {
	// 	icon: "iconfont icon-tubiao-huanbao",
	// 	router: "/admin/ver",
	// 	name: "系统管理",
	// },
	// {
	// 	icon: "iconfont icon-ludeng",
	// 	router: "/admin/task",
	// 	name: "任务管理",
	// },
	{
    icon:"icon icon-xitongrizhi",
    router:'/admin/task',
    name:'设备日志',
    children:[
      {
        icon: "iconfont icon-ludeng",
        router: "/admin/task",
        name: "任务日志",
      },{
        icon:"iconfont icon-jiancejilu-xian",
        router:"/admin/DetectionRecord",
        name:"检测记录",
      }
    ]
  }
]
export default deviceAuth
